module.exports = __webpack_public_path__ + "img/5-4.ae3d16e9.png";